module.exports = __webpack_public_path__ + "img/other.85e93b1d.jpg";